import attributionPostbacksImageSrc from '../resources/png/teamManagement/attribution_postbacks.png';
import attributionWindowSettingsImageSrc from '../resources/png/teamManagement/attribution_window_settings.png';
import configurationCredentialsImageSrc from '../resources/png/teamManagement/configuration_credentials.png';
import eventPostbacksImageSrc from '../resources/png/teamManagement/event_postbacks.png';
import linkAttributionSettingsImageSrc from '../resources/png/teamManagement/link_attribution_settings.png';
import linkOgTagsImageSrc from '../resources/png/teamManagement/link_og_tags.png';
import linkParametersImageSrc from '../resources/png/teamManagement/link_parameters.png';
import linkSettingsAndRedirectsImageSrc from '../resources/png/teamManagement/link_settings_and_redirects.png';
import { SECTIONS, SECTION_ACCESS_TYPES } from '../utils/consts';
import { MANAGE_PERMISSIONS_STEPS, translationPrefix as translationRootPrefix } from './utils';

const translationPrefix = `${translationRootPrefix}.MANAGE_PERMISSIONS_PAGE`;

// Preload images
[
    configurationCredentialsImageSrc,
    attributionPostbacksImageSrc,
    attributionWindowSettingsImageSrc,
    eventPostbacksImageSrc,
    linkSettingsAndRedirectsImageSrc,
    linkParametersImageSrc,
    linkAttributionSettingsImageSrc,
    linkOgTagsImageSrc,
].forEach(src => {
    const img = new Image();
    img.src = src;
});

export const SECTIONS_PAGES_CONFIG = [
    {
        step: MANAGE_PERMISSIONS_STEPS.attribution,
        page: {
            key: 'new_partner_config',
            link: 'react/partner-config',
            translationKey: `${translationPrefix}.ATTRIBUTION.PAGE_DISPLAY_NAME`,
        },
        cards: [
            {
                title: `${translationPrefix}.ATTRIBUTION.TITLE`,
                description: `${translationPrefix}.ATTRIBUTION.DESCRIPTION`,
                parts: [
                    {
                        sectionNames: [SECTIONS.PARTNER_CONFIGURATION_CREDENTIALS],
                        tooltipImageSrc: configurationCredentialsImageSrc,
                        tooltipDescriptionSectionName: SECTIONS.PARTNER_CONFIGURATION_CREDENTIALS,
                    },
                    {
                        displayName: `${translationPrefix}.ATTRIBUTION.ATTRIBUTION_POSTBACKS.DISPLAY_NAME`,
                        sectionNames: [
                            SECTIONS.PARTNER_CONFIGURATION_ATTRIBUTION_INSTALL_POSTBACKS,
                            SECTIONS.PARTNER_CONFIGURATION_ATTRIBUTION_REENGAGEMENT_POSTBACKS,
                        ],
                        tooltipImageSrc: attributionPostbacksImageSrc,
                    },
                    {
                        sectionNames: [SECTIONS.PARTNER_CONFIGURATION_ATTRIBUTION_WINDOW_SETTINGS],
                        tooltipImageSrc: attributionWindowSettingsImageSrc,
                    },
                    {
                        sectionNames: [SECTIONS.PARTNER_CONFIGURATION_IN_APP_EVENTS_POSTBACK],
                        tooltipImageSrc: eventPostbacksImageSrc,
                    },
                ],
            },
        ],
    },
    {
        step: MANAGE_PERMISSIONS_STEPS.links,
        page: {
            key: 'manage_links',
            link: 'react/link-management',
            translationKey: `${translationPrefix}.LINKS.PAGE_DISPLAY_NAME`,
        },
        cards: [
            {
                title: `${translationPrefix}.LINKS.PARTNER_LINKS.TITLE`,
                description: `${translationPrefix}.LINKS.PARTNER_LINKS.DESCRIPTION`,
                parts: [
                    {
                        sectionNames: [SECTIONS.MANAGE_LINKS_PARTNER_LINK_SETTINGS_AND_REDIRECTS],
                        tooltipImageSrc: linkSettingsAndRedirectsImageSrc,
                    },
                    {
                        sectionNames: [SECTIONS.MANAGE_LINKS_PARTNER_ATTRIBUTION_SETTINGS],
                        tooltipImageSrc: linkAttributionSettingsImageSrc,
                    },
                ],
            },
            {
                title: `${translationPrefix}.LINKS.CUSTOM_SOURCE_LINKS.TITLE`,
                description: `${translationPrefix}.LINKS.CUSTOM_SOURCE_LINKS.DESCRIPTION`,
                parts: [
                    {
                        sectionNames: [SECTIONS.MANAGE_LINKS_CUSTOM_LINK_SETTINGS_AND_REDIRECTS],
                        tooltipImageSrc: linkSettingsAndRedirectsImageSrc,
                    },
                    {
                        sectionNames: [SECTIONS.MANAGE_LINKS_CUSTOM_ATTRIBUTION_SETTINGS],
                        tooltipImageSrc: linkAttributionSettingsImageSrc,
                    },
                    {
                        sectionNames: [SECTIONS.MANAGE_LINKS_CUSTOM_OG_TAGS],
                        tooltipImageSrc: linkOgTagsImageSrc,
                    },
                    {
                        sectionNames: [SECTIONS.MANAGE_LINKS_CUSTOM_LINK_PARAMETERS],
                        tooltipImageSrc: linkParametersImageSrc,
                    },
                ],
            },
        ],
    },
];

export const SECTION_PAGES_STEPS = SECTIONS_PAGES_CONFIG.map(({ step }) => step);

// Map of page names to their section names for view-only control
export const VIEW_ONLY_PAGES_MAP = {
    ...SECTIONS_PAGES_CONFIG.reduce((map, config) => {
        map[config.page.key] = config.cards.flatMap(card => card.parts.flatMap(part => part.sectionNames));
        return map;
    }, {}),
    singularevents: [SECTIONS.SINGULAR_EVENTS_MANAGE],
    conversion_models: [SECTIONS.CONVERSION_MODELS_MANAGE],
    audiences_segments: [SECTIONS.AUDIENCES_SEGMENTS_MANAGE],
    audiences_distributions: [SECTIONS.AUDIENCES_DISTRIBUTIONS_MANAGE],
    'custom-dimensions': [SECTIONS.CUSTOM_DIMENSIONS_MANAGE],
    alerts_v2: [SECTIONS.ALERTS_MANAGE],
};

export const isScreenViewOnly = (screenName, sectionPermissions) => {
    const sections = VIEW_ONLY_PAGES_MAP[screenName];
    if (!sections) return false;
    const relevantPermissions = sectionPermissions.filter(sp => sections.includes(sp.name));
    return (
        relevantPermissions.length > 0 && relevantPermissions.every(sp => sp.access_type === SECTION_ACCESS_TYPES.VIEW)
    );
};
